<template lang="pug">

    .ui.card

        .content
            h3.ui.center.aligned.icon.header
                i.circular.plus.link.icon(v-on:click='showModal()')
                .content Adressse hinzufügen

        modal(ref="modal")
            span(slot="header") Adresse ändern

            div(slot="content").ui.form

                //- Adresse
                address-dropdown-field(
                    v-bind:address-models='addressModelOptions'
                    v-bind:company-model='companyModel'
                    v-bind:country-models='countryModels'
                    v-bind:force-shipping-address='true'
                    v-bind:person-models='personModels'
                    v-model="model.address"
                )

                //- Abweichende Ansprechperson
                persons-dropdown-field(
                    label="Abweichende Ansprechperson"
                    v-bind:company-model='companyModel'
                    v-bind:person-models='personModels'
                    v-model="contactId"
                )

                //- Anzahl
                number-field(label="Anzahl" v-model.number="model.amount" v-bind:min='0')

                //- Lieferbedingungen
                textarea-field(label="Lieferbedingungen" v-model.trim="model.deliveryConditions")

            action-row(
                slot="footer"
                v-on:cancel="closeModal()"
                v-on:save="save()"
            )

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import * as AddressUtils from '@/utils/address'
    import ActionRow from '@/components/form/ActionRow.vue'
    import AddressDropdownField from '@/components/addresses/DropdownField'
    import Modal from '@/components/app/Modal.vue'
    import NumberField from '@/components/form/NumberField.vue'
    import PersonsDropdownField from '@/components/persons/DropdownField'
    import TextareaField from '@/components/form/TextareaField.vue'

    // noinspection JSUnusedGlobalSymbols
    // noinspection ReservedWordAsName
    export default {

        components: { ActionRow, AddressDropdownField, Modal, NumberField, PersonsDropdownField, TextareaField },

        computed: {

            addressModelOptions() {
                return R.compose(

                    // Namen von Standardlieferadresse formatieren
                    R.map(AddressUtils.format_name_by_default_shipping_address),

                    // Nach Standard-Lieferadresse sortieren
                    AddressUtils.sort_by_is_default_shipping_address

                )(this.addressModels)
            },

            contactId: {
                get() { return R.defaultTo(0, this.model.contact) },
                set(value) { this.$set(this.model, 'contact', value) },
            },

        },

        data() {
            return {
                model: {
                    product: this.productModel.id,
                    address: AddressUtils.find_default_shipping_address(this.addressModels).id
                }
            }
        },

        methods: {
            closeModal() {
                this.$refs.modal.close()
            },

            save() {
                // Wenn Anzahl 0 ist, dann `null`en
                if (this.model.amount === 0) {
                    this.model.amount = null
                }

                store.dispatch('shippingAddresses/create', { model: this.model }).then(() => {
                    this.closeModal()
                    this.$growl.success('Lieferadresse erstellt')
                }).catch(() => {
                    this.$growl.error('Lieferadresse konnte nicht aktualisiert werden')
                })
            },

            showModal() {
                this.$refs.modal.show()
            }
        },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            companyModel: {
                type: Object,
                required: true
            },

            countryModels: {
                type: Array,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

        }

    }

</script>

<style scoped>

    /*noinspection CssUnusedSymbol*/
    .card .content .header {
        padding-top: 12%;
    }

</style>
